import React, { useState } from "react";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { DataSourceUpdate } from "./dataSourceUpdate";
import { ConfirmationDialog } from "../../common/confirmationDialog";
import { AddNew } from "../../uiControls/addNew";

const dataSourceColumns = [
  {
    label: "Name",
    keyField: "datasourceKey",
    dataField: "name",
  },
  {
    label: "Description",
    keyField: "datasourceKey",
    dataField: "description",
  },
  {
    label: "Status",
    keyField: "datasourceKey",
    dataField: "active",
    minWidth: 20,
    maxWidth: 20,
  },
  {
    label: "",
    keyField: "datasourceKey",
    dataField: "datasourceKey",
    minWidth: 20,
    maxWidth: 20,
  },
];

const dataSourceSearchColumns = ["name", "description"];

export const DataSourceConfig = () => {
  const [updateOpen, setUpdateOpen] = useState(false);
  const [dataSourceEdit, setDataSourceEdit] = useState(null);
  const [dataSourceAttributes, setDataSourceAttributes] = useState({
    datasourceKey: 0,
    name: "",
    description: "",
    active: true,
    fileTypes: [],
  });
  const [dataSourceFileTypeAttributes, setDataSourceFileTypeAttributes] =
    useState({
      fileTypeKey: 0,
      rowToStartWith: 0,
      active: true,
      name: "",
    });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmationDialogAttributes, setConfirmationDialogAttributes] =
    useState({});

  const { sendRequest: fetchDataSourceDetails } = useHttpRequests();

  const dataSourceEditHandler = (e, key) => {
    e.stopPropagation();
    if (updateOpen) {
      //alert("Are you sure to discard your changes?");
      //TODO: confirmation for data loss
      return false;
    }

    const getDataSourceDetails = (dataSourceObj) => {
      if (
        !dataSourceObj ||
        !dataSourceObj.isSuccess ||
        dataSourceObj.errorResponse
      ) {
        console.log("Data source fetch response returns error");
        return;
      }

      setDataSourceAttributes({
        datasourceKey: dataSourceObj["datasource"]["datasourceKey"],
        name: dataSourceObj["datasource"]["name"],
        description: dataSourceObj["datasource"]["description"],
        active: dataSourceObj["datasource"]["active"],
        fileTypes: dataSourceObj["fileTypes"],
      });
      setDataSourceFileTypeAttributes(dataSourceObj["fileTypes"]);

      setDataSourceEdit(true);
      setUpdateOpen(true);
    };

    fetchDataSourceDetails(
      { url: "DataSources/" + key, method: "GET", header: true },
      getDataSourceDetails
    );
  };

  const changeDataSourceStatus = (e, key, status, name) => {
    e.stopPropagation();
    if (updateOpen || dialogOpen) {
      return false;
    }
    setConfirmationDialogAttributes({
      title: "Data source status change confirmation!",
      message:
        "Are you sure to mark " +
        (status ? "active" : "inactive") +
        " the " +
        name +
        "?",
      confirmText: "Yes",
      cancelText: "No",
      url: "DataSources/",
      keyField: "datasourceKey",
      key: key,
      status: status,
      messageTitle: name,
    });
    setDialogOpen(true);
  };

  const getUrl = (params) => {
    return "DataSources";
  };

  const dataSourceDetailProps = {
    setUpdateOpen,
    dataSourceEdit,
    setDataSourceEdit,
    dataSourceAttributes,
    dataSourceFileTypeAttributes,
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <ConfirmationDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        confirmationDialogAttributes={confirmationDialogAttributes}
      />
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        {!updateOpen && (
          <>
            <TableWithStickyHeader
              pagging={false}
              columns={dataSourceColumns}
              url={getUrl}
              sourceObj="datasources"
              editHandler={dataSourceEditHandler}
              updateOpen={updateOpen}
              searchOnColumns={dataSourceSearchColumns}
              changeStatus={changeDataSourceStatus}
              searchPlace="right"
            />

            <AddNew
              onClickCall={() => {
                setDataSourceAttributes({
                  datasourceKey: 0,
                  name: "",
                  description: "",
                  active: true,
                  fileTypes: [],
                });
                setDataSourceFileTypeAttributes({
                  fileTypeKey: 0,
                  rowToStartWith: 0,
                  active: true,
                });
                setUpdateOpen(true);
              }}
            />
          </>
        )}
      </div>
      {updateOpen && (
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <DataSourceUpdate {...dataSourceDetailProps} />
        </div>
      )}
    </div>
  );
};
